@if (!!(isLoading$ | async)) {
  <div class="d-flex flex-column justify-content-center align-items-center h-100">
    <app-loading></app-loading>
  </div>
} @else {
  @let styleClass = dealsLayoutStyle$ | async;
  @if (account$ | async; as account) {
    @if (allowToViewAccount$ | async; as allowToViewAccount) {
      <div class="d-flex flex-column gap-3"
        [ngClass]="styleClass"
        >
        <ul ngbNav [activeId]="route.fragment | async" class="rmv-tabs __tabs">
          <li class="rmv-tabs__item" ngbNavItem="details" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['details']">Details</a>
          </li>
          <li class="rmv-tabs__item" ngbNavItem="contacts" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['contacts']">Contacts</a>
          </li>
          <li class="rmv-tabs__item" ngbNavItem="tasks" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['tasks']">Tasks</a>
          </li>
          @if (allowToViewAccount.visibility === 'edit') {
            @let lng = account.geoDetails?.location?.coordinates?.[0];
            @let lat = account.geoDetails?.location?.coordinates?.[1];
            @if (lng && lat) {
              <li class="rmv-tabs__item" ngbNavItem="daily-routes" routerLinkActive="--active">
                <a class="rmv-tabs__link" ngbNavLink [routerLink]="['daily-routes']">Daily Route</a>
              </li>
            }
            <li class="rmv-tabs__item" ngbNavItem="deals" routerLinkActive="--active">
              <a class="rmv-tabs__link" ngbNavLink [routerLink]="['deals']">Deals</a>
            </li>
          }
          <li class="rmv-tabs__item" ngbNavItem="account-activity-logs" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['documents']">Documents</a>
          </li>
          @if (account.tags && account.tags.length > 0) {
            <li class="rmv-tabs__item" ngbNavItem="shared" routerLinkActive="--active">
              <a class="rmv-tabs__link" ngbNavLink [routerLink]="['shared']">Shared Tags</a>
            </li>
          }
          <li class="rmv-tabs__item" ngbNavItem="account-activity-logs" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['account-activity-logs']">Activity Logs</a>
          </li>
          @if (account.scope !== 'child') {
            <li class="rmv-tabs__item" ngbNavItem="account-activity-logs" routerLinkActive="--active" *ngrxLet="industry$; let industry">
              <a class="rmv-tabs__link" ngbNavLink [routerLink]="['children']">
                {{ accountCaptions.child | scopeCaption: industry : scopeCaptions() }}(s)
              </a>
            </li>
          }
          <li class="rmv-tabs__item" ngbNavItem="account-activity-logs" routerLinkActive="--active">
            <a class="rmv-tabs__link" ngbNavLink [routerLink]="['equipment']">
              {{ equipmentCaptions().plural }}
            </a>
          </li>
        </ul>
        <div [ngClass]="styleClass">
          <router-outlet></router-outlet>
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="notFound"></ng-container>
    }
  } @else {
    <ng-container *ngTemplateOutlet="notFound"></ng-container>
  }
  <ng-template #notFound>
    <div class="d-flex flex-column justify-content-center align-items-center gap-4 h-100">
      <span class="__icon-settings rmv-icon-ic-settings"></span>
      <div class="d-flex flex-column justify-content-center align-items-center gap-2">
        <p class="__not-found-title">Account not found</p>
        <p>Account was deleted, or you do not have access to view the record.</p>
      </div>
    </div>
  </ng-template>
}
